/**
 * One key for the support session state, shared by the Ops Center tab and the
 * banner: two keys meant two caches of the same endpoint, and invalidating one
 * left the other stale.
 */
export const SUPPORT_ACCESS_QUERY_KEY = ['supportAccess'];

/**
 * A root of its own, and not a child of the key above: react-query invalidates
 * by prefix, so nesting it would refetch every cached search whenever the
 * session state is invalidated.
 */
export const SUPPORT_ACCESS_CANDIDATES_KEY = ['supportAccessCandidates'];
